import React from 'react'
import { FechasPermisosMedicosVacaciones, PlanificacionSolicitudVacaciones, Replanificacion, SolicitudReintegroVacaciones, SolicitudVacaciones } from '../TypesSolicitudVacaciones';
import { SumarDiasFecha, obtener_rango_fechas_no_weekend } from 'functions/DatesFunctions';
import Datepicker from 'components/Varios/Datepicker';
import { isFeriado, isFeriadoFilter, isWeekday } from 'functions/CalendarFunctions';

type PropsDatePickerReprogramacion = {
    planificaciones: PlanificacionSolicitudVacaciones[],
    listadoReplanificaciones: Replanificacion[],
    feriados: Date[],
    fechasPermisosMedicos: FechasPermisosMedicosVacaciones[],
    fechasLicencia: {
        fechadesde: Date,
        fechahasta: Date    
    }[],
    solicitudes: SolicitudVacaciones[],
    solicitudesReintegro: SolicitudReintegroVacaciones[],
    onChangeDate:(value:Date|undefined) => void,
    valueDate:Date|undefined
    solicitudVacacionDeReintegro?:SolicitudVacaciones,
    fechaReintegro?:Date|string,
    valueDesdeDate?:Date,
    tipo:"desde"|"hasta",
    solicitudReprogramando:"reintegro"|"vacaciones"|"anulacion"
}

export default function DatePickerReprogramacion(props: PropsDatePickerReprogramacion) {

    const {listadoReplanificaciones,solicitudVacacionDeReintegro,tipo,solicitudReprogramando,fechaReintegro} = props;

    const fechaActual = new Date();
    var fechaminima = SumarDiasFecha(fechaActual, 1);



    var fechamaxima = new Date(fechaActual.getFullYear(), 11, 31)

    if(solicitudVacacionDeReintegro !== undefined && solicitudReprogramando === "reintegro" && fechaReintegro !== undefined){
        const fechaFinSolicitudVacacionDeReintegro = new Date(solicitudVacacionDeReintegro.fechaFin);
        
        if(tipo === 'desde' ) {
            fechaminima = SumarDiasFecha(new Date(fechaReintegro),1);
        }
        else if (tipo === "hasta" && props.valueDesdeDate !== undefined){
            fechaminima = props.valueDesdeDate
        }
        
        
    }
    else if(solicitudVacacionDeReintegro !== undefined && solicitudReprogramando === "anulacion"){
        if (tipo === "hasta" && props.valueDesdeDate !== undefined){
            fechaminima = props.valueDesdeDate
        }
    }


    const feriados = props.feriados.map((val, ind) => {
        return new Date(val)
    })
    var fechasExcluidas: Date[] = [...feriados];

    if (props.fechasLicencia.length > 0) {

        props.fechasLicencia.map((val, ind) => {
            const { fechadesde, fechahasta } = val;
            fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechadesde, fechahasta)]
        })

    }

    if(props.planificaciones.length > 0 ) {
        props.planificaciones.map((val, ind) => {
            const { fechaInicio, fechaFin } = val;

            if (solicitudVacacionDeReintegro !== undefined && solicitudReprogramando === "anulacion" && solicitudVacacionDeReintegro.fechaInicio !== fechaInicio && solicitudVacacionDeReintegro.fechaFin !== fechaFin) {
                fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechaInicio, fechaFin)]
            }

            
        })
    }

    if (props.fechasPermisosMedicos.length > 0) {
        props.fechasPermisosMedicos.map((val, ind) => {
            const { fechaDesde, fechaHasta } = val;
            
            //Si la propiedad indica que no se debe permitir en dias, significa que esa fecha no es seleccionable como dia a reprogramar, por lo que se 
            //deberia agregar a fechas excluidas

            if(!val.permitirEnDias) {
                fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechaDesde, fechaHasta)]
            }
            
        })

    }

    if (listadoReplanificaciones.length > 0) {
        listadoReplanificaciones.map((val, ind) => {
            const { fechaInicio, fechaFin } = val;
            fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechaInicio, fechaFin)]
        })
    }

    // var nuevasFechasEscogidas: Date[] = []

    // if (props.solicitudes.length > 0) {
    //     props.solicitudes.map((val, ind) => {
    //         const { fechaInicio, fechaFin } = val;
    //         var rangoFechasExcluir = [...obtener_rango_fechas_no_weekend(fechaInicio, fechaFin)]
    //         const solicitudReintegro = props.solicitudesReintegro.find((v) => v.idSolicitudVacaciones === val.idSolicitud);
    //         const tieneReintegro = solicitudReintegro !== undefined;
    //         if (solicitudReintegro !== undefined) {
    //             rangoFechasExcluir = [...obtener_rango_fechas_no_weekend(fechaInicio, solicitudReintegro.fechaReintegro)]
    //         }
    //         nuevasFechasEscogidas = [...nuevasFechasEscogidas, ...rangoFechasExcluir]

    //     })

    //     fechasExcluidas = [...fechasExcluidas, ...nuevasFechasEscogidas]
    // }






    return (
        <Datepicker
            value={props.valueDate}
            name="fechadesde"
            id="fechadesde"
            onChange={(e) => props.onChangeDate(e)}
            min={fechaminima}
            max={fechamaxima}

            filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, props.feriados)}
            showDisabledMonthNavigation={true}
            excludeDates={fechasExcluidas}
            dayClassName={(date: Date) => isFeriado(date, props.feriados)}
        />
    )
}
